module.exports = __webpack_public_path__ + "static/media/innovators-guide.1a02bdbd.svg";